import { SidekickSupportedTms } from '@shared/generated/graphql';
import { EntityInfo, SupportedEntityType, TMSPageInfo } from './types';

export function getMcleodWebPageInfo(url: string): TMSPageInfo {
  return {
    pageType: 'tms',
    tms: SidekickSupportedTms.MCLEOD_WEB,
    entityInfo: getEntityInfo(url),
  };
}

function getEntityInfo(url: string): EntityInfo[] {
  const orderIdPattern = /orderId=(\d+)/;
  const keyPattern = /key=(\d+)/;

  const orderIdMatch = url.match(orderIdPattern);
  if (orderIdMatch) {
    return [
      {
        entityType: SupportedEntityType.SHIPMENT,
        entityReference: orderIdMatch[1],
      },
    ];
  }

  const keyMatch = url.match(keyPattern);
  if (keyMatch) {
    return [
      {
        entityType: SupportedEntityType.SHIPMENT,
        entityReference: keyMatch[1],
      },
    ];
  }

  return [];
}
